// extracted by mini-css-extract-plugin
export default {"table":"table_table__J2ot0","cellWrapper":"table_cellWrapper__+1Q98","image":"table_image__FfwvT","productStatus":"table_productStatus__+0LF3"};